// extracted by mini-css-extract-plugin
export default {"ContactRow":"style_ContactRow__diLkW"};